var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* ログ一覧画面 */
import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import { Button } from 'react-bootstrap';
import LogResultList from '../molecules/LogResultList';
import LogSearchForm from '../organisms/LogSearchForm';
import LoadingModal from '../organisms/LoadingModal';
import axios from '../axios';
import { handleBrowzerBack } from '../BrowzerBack';
import { log_search_params_init } from '../Const';
import { parse } from 'querystring';
import { jumpUrl } from '../Common';
import Moment from 'moment';
var LogList = function () {
    var _a = useState([]), log_list = _a[0], setLogList = _a[1];
    var _b = useState({
        display_list_number: [],
    }), config = _b[0], setConfig = _b[1];
    var _c = useState(), options = _c[0], setOptions = _c[1];
    var _d = useState([]), messages = _d[0], setMessages = _d[1];
    // 検索パラメータの初期化
    var _e = useState(log_search_params_init), search_params = _e[0], setSearchParams = _e[1];
    // 最新の検索実行時のパラメータ
    var _f = useState(false), is_loading = _f[0], setIsLoading = _f[1];
    // Ajaxリクエスト中フラグ
    var _g = useState(false), is_connecting = _g[0], setIsConnecting = _g[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        /**
         * ログを検索する
         * @param params 検索パラメータ
         */
        var searchLogs = function (params) { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        return [4 /*yield*/, axios.post('/staff/log_list/search', params)];
                    case 1:
                        response = _a.sent();
                        setLogList(response.data.log_list);
                        setConfig(response.data.config);
                        setOptions(response.data.options);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.response.data.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 検索パラメータの初期値を設定
        var new_params = Object.assign({}, search_params);
        // 開始日時セット
        var start_date = new Date();
        start_date.setDate(start_date.getDate() - 3);
        new_params.created_at_from_ymd =
            start_date.getFullYear() + '-' + (start_date.getMonth() + 1) + '-' + start_date.getDate();
        new_params.created_at_from_hour = ('0' + start_date.getHours()).slice(-2);
        new_params.created_at_from_minute = ('0' + start_date.getMinutes()).slice(-2);
        // 終了日時セット
        var end_date = new Date();
        new_params.created_at_to_ymd =
            end_date.getFullYear() + '-' + (end_date.getMonth() + 1) + '-' + end_date.getDate();
        new_params.created_at_to_hour = ('0' + end_date.getHours()).slice(-2);
        new_params.created_at_to_minute = ('0' + end_date.getMinutes()).slice(-2);
        setSearchParams(new_params);
        if (location.search.length > 0) {
            // getパラメータをパースする
            var get_queries = parse(location.search.slice(1));
            // 検索パラメータの初期化状態にマージする
            Object.assign(new_params, get_queries);
            // パラメータを更新する
            setSearchParams(new_params);
        }
        // Ajaxリクエスト
        searchLogs(new_params);
    }, []);
    // 検索処理
    var handleClickSearch = useCallback(function () {
        // クリックイベント
        var searchLogList = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, exception_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        setMessages([]);
                        return [4 /*yield*/, axios.post('/staff/log_list/search', search_params)];
                    case 1:
                        response = _a.sent();
                        setLogList(response.data.log_list);
                        return [3 /*break*/, 4];
                    case 2:
                        exception_1 = _a.sent();
                        console.error(exception_1);
                        setMessages(exception_1.response.data.message);
                        jumpUrl(exception_1.response.data.url);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsConnecting(false);
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        searchLogList();
    }, [search_params]);
    //
    var handleChangeSearchParams = useCallback(function (target, param) {
        var set_param = '';
        var params = Object.assign({}, search_params);
        var set_targets = [];
        // targetが単一stringであるかをチェックする
        if (typeof target === 'string') {
            set_targets.push(target);
        }
        else {
            target.map(function (param) { return set_targets.push(param); });
        }
        // targetの個数分だけ繰り返しパラメータをセットする
        set_targets.map(function (target_param) {
            if (Object.prototype.toString.call(param).slice(8, -1).toLowerCase() === 'date') {
                // Date型
                set_param = Moment(param).format('YYYY-MM-DD');
            }
            else if (typeof param === 'string') {
                // string型
                set_param = param;
            }
            var key = target_param; // targetの型を明示的に指定
            params[key] = set_param;
        });
        setSearchParams(params);
    }, [search_params]);
    /**
     * 戻るボタンをクリックする
     */
    var handleClickReturn = function () {
        location.replace("" + location.origin + process.env.MIX_MOCK_URL + "/staff/list");
    };
    return (React.createElement("div", { className: "container" },
        React.createElement(LogSearchForm, { options: options, search_params: search_params, message: messages, handleClickSearch: handleClickSearch, handleChangeSearchParams: handleChangeSearchParams, is_connecting: is_connecting }),
        React.createElement(LogResultList, { projects: log_list, config: config }),
        React.createElement("div", { className: "mt-4 text-center" },
            React.createElement(Button, { variant: "main-color", className: "return-button", size: "lg", onClick: handleClickReturn }, "\u623B\u308B")),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('log-list')) {
    render(React.createElement(LogList, null), document.getElementById('log-list'));
}
